module.exports = __webpack_public_path__ + "glyphicons-regular.66389e0821c969a25739.eot";


//////////////////
// WEBPACK FOOTER
// /opt/app/develop/src/assets/css/fonts/glyphicons.pro/glyphicons-regular.eot
// module id = ../../../../../src/assets/css/fonts/glyphicons.pro/glyphicons-regular.eot
// module chunks = 2